// tslint:disable:trailing-comma
export var legacyConfigRoutes = [
    // Deprecated or merged with other feature(s)/Menu-Item(s)
    // {
    //   name: 'BOL XREF',
    //   path: `/Shepherd2/BOLXRef.aspx`,
    //   redirect: '/legacy/BOLXRef.aspx',
    //   meta: {
    //     includeInMenu: true,
    //     settings: true,
    //     authorize: 'BOL_XREF',
    //   },
    // },
    {
        name: 'Bio Load Planning',
        path: "/Shepherd2/BioSchedule.aspx",
        redirect: '/legacy/BioSchedule.aspx',
        meta: {
            includeInMenu: true,
            settings: true,
            authorize: '$_BIO_LOAD_PLANNING',
        },
    },
    {
        name: 'Email History',
        path: "/Shepherd2/EmailHistory.aspx",
        redirect: '/legacy/EmailHistory.aspx',
        meta: {
            includeInMenu: true,
            settings: true,
            authorize: '$_EMAIL_HISTORY',
        },
    },
    {
        name: 'Fuel Sale Adjustments',
        path: "/Shepherd2/SaleAdjustments.aspx",
        redirect: '/legacy/SaleAdjustments.aspx',
        meta: {
            includeInMenu: true,
            settings: true,
            authorize: '$_FUEL_SALE_ADJUSTMENTS',
        },
    },
    {
        name: 'Fuel Sale Exclusions',
        path: "/Shepherd2/SaleExclusions.aspx",
        redirect: '/legacy/SaleExclusions.aspx',
        meta: {
            includeInMenu: true,
            settings: true,
            authorize: '$_FUEL_SALE_EXCLUSIONS',
        },
    },
    {
        name: 'Inventory Constraints',
        path: "/Shepherd2/InventoryConstraints.aspx",
        redirect: '/legacy/InventoryConstraints.aspx',
        meta: {
            includeInMenu: true,
            settings: true,
            authorize: '$_INVENTORY_CONSTRAINTS',
        },
    },
    {
        name: 'Inventory Master',
        path: "/Shepherd2/InventoryMaster.aspx",
        redirect: '/legacy/InventoryMaster.aspx',
        meta: {
            includeInMenu: true,
            settings: true,
            authorize: '$_INVENTORY_MASTER',
        },
    },
    {
        name: 'Inventory Targets',
        path: "/Shepherd2/InventoryTargets.aspx",
        redirect: '/legacy/InventoryTargets.aspx',
        meta: {
            includeInMenu: true,
            settings: true,
            authorize: '$_INVENTORY_TARGETS',
        },
    },
    {
        name: 'Material Recipe',
        path: "/Shepherd2/MaterialRecipe.aspx",
        redirect: '/legacy/MaterialRecipe.aspx',
        meta: {
            includeInMenu: true,
            settings: true,
            authorize: '$_MATERIAL_RECIPE',
        },
    },
    {
        name: 'Midnight Meter Entry',
        path: "/Shepherd2/MidnightMeter.aspx",
        redirect: '/legacy/MidnightMeter.aspx',
        meta: {
            includeInMenu: true,
            settings: true,
            authorize: '$_MIDNIGHT_METER_ENTRY',
        },
    },
    {
        name: 'Midnight Meter Readings',
        path: "/Shepherd2/MidnightMeterReadings.aspx",
        redirect: '/legacy/MidnightMeterReadings.aspx',
        meta: {
            includeInMenu: true,
            settings: true,
            authorize: '$_MIDNIGHT_METER_READING',
        },
    },
    {
        name: 'Region Master',
        path: "/Shepherd2/RegionMaster.aspx",
        redirect: '/legacy/RegionMaster.aspx',
        meta: {
            includeInMenu: true,
            settings: true,
            authorize: '$_REGION_MASTER',
        },
    },
    {
        name: 'Schedule',
        path: "/Shepherd2/dailyConfig.aspx",
        redirect: '/legacy/dailyConfig.aspx',
        meta: {
            includeInMenu: true,
            settings: true,
            authorize: '$_SCHEDULE',
        },
    },
    {
        name: 'Site Master',
        path: "/Shepherd2/SiteMaster.aspx",
        redirect: '/legacy/SiteMaster.aspx',
        meta: {
            includeInMenu: true,
            settings: true,
            authorize: '$_SITE_MASTER',
        },
    },
    {
        name: 'Wholesale Master',
        path: "/Shepherd2/WholesaleMaster.aspx",
        redirect: '/legacy/WholesaleMaster.aspx',
        meta: {
            includeInMenu: true,
            settings: true,
            authorize: '$_WHOLESALE_MASTER',
        },
    },
    ,
    {
        name: 'ZFAR Pending',
        path: "/Shepherd2/ZFARPending.aspx",
        redirect: '/legacy/ZFARPending.aspx',
        meta: {
            includeInMenu: true,
            settings: true,
            authorize: '$_ZFAR_PENDING',
        },
    },
];
